import DirectoryService from "components/app/directory/DirectoryService";
import ClassService from "../classes/ClassService";

const ProgrammingService = {
  async saveProgramming(formData) {
    try {
      let url = '/api/<your_controller>';
      let method = 'PUT';
      if (formData.identifier === undefined) {
        const profileLogged = JSON.parse(localStorage.getItem('profile'));
        const { accountIdentifier } = profileLogged;
        console.log(profileLogged);
        console.log(accountIdentifier);
        url = '/api/<your_controller>';
        method = 'POST';
      }

      const response = await fetch(url, {
        method: method,
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });
      if (response.ok) {
        const newProgramming = await response.json();
        console.log('Programming has been updated:', newProgramming);
      }
    } catch (error) {
      console.log('Error saving Programming', error);
    }
  },
  async getTypes() {
    const profileLogged = JSON.parse(localStorage.getItem('profile'));
    const { accountIdentifier } = profileLogged;
    try {
      const response = await fetch(
        '/api/wod/wodclass/account/' + accountIdentifier + '/types'
      );
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching Programming types', error);
      throw error;
    }
  },
  async retrieveTodaysWOD() {
    try {
      const today = new Date().toISOString().split('T')[0];
      //TODO it should take the last one if there's not wod for today.
      const allProgrammingByAccount =
        await this.retrieveAllProgrammingByAccount();
      const profile = DirectoryService.retrieveLoggedProfile();
      console.log('AllProgrammingByAccount: ', allProgrammingByAccount);
      let todaysWOD = allProgrammingByAccount.filter(p=>p.date === today)[0];
      console.log('TodaysWOD after filter', todaysWOD);
      if( todaysWOD === undefined){
        todaysWOD =  allProgrammingByAccount[0];
      }
      console.log('AllProgrammings', allProgrammingByAccount);
      console.log('TodaysWOD', todaysWOD);
      const wodClasses = await ClassService.retrieveAllClassesByAccount();

      //const wodClass = wodClasses.filter(c=>c.date === todaysWOD.date);

      const wodClass = wodClasses.filter(c=>c.date === today)[0];
      console.log('WodClass after filter', wodClass);
      if( wodClass === undefined){
        const mockData = {
          title: 'Cindy',
          type: 'Demo WOD',
          description: '(This is a Demo Class) As many rounds as possible (AMRAP) in 20 minutes of 5 pull-ups, 10 push-ups, and 15 air squats.',
          coach: 'Demo Coach',
          classTime: new Date().toISOString(),
          duration: '60 min',
          status: 'no-class',
          spotsLeft: 0,
          totalSpots: 0,
          startTime: new Date().toISOString().split('T')[1].substring(0,5),
          endTime: 'N/A',
          date: new Date().toISOString().split('T')[0]
        };
        console.log('Mock data', mockData);
        return mockData;
      }  
      const isComming = wodClass?.attendees.find(a=>a.identifier === profile.identifier) ? 'booked' : 'no-booked';
      const updatedData = {
        title: todaysWOD?.type,
        type: 'Hero WOD',
        description: todaysWOD?.strength || todaysWOD?.workout || 'No description available',
        coach: wodClass?.coach,
        classTime: wodClass?.date + 'T' + wodClass?.startTime,
        duration: '60 min',
        status: isComming,
        spotsLeft: wodClass?.maxCapacity - wodClass?.attendees.length,
        totalSpots: wodClass?.maxCapacity,
        startTime: wodClass?.startTime,
        endTime: wodClass?.endTime,
        date: wodClass?.date
      };
      
      console.log('Updated data', updatedData);
      return updatedData;
    } catch (error) {
        console.error('Error fetching Programming', error);
      throw error;
    }
  },
  async retrieveAllProgrammingByAccount() {
    try {
      const { accountIdentifier } = JSON.parse(localStorage.getItem('profile'));
      console.log(accountIdentifier);
      const response = await fetch(
        '/api/wod/program/account/' + accountIdentifier
      );
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching Programming', error);
      throw error;
    }
  },
  async retrieveProgram(accountIdentifier, date, type) {
    console.log('Retrieving program for accountIdentifier:', accountIdentifier, 'date:', date, 'type:', type);  
    try {
      //TODO Change this logic
      const response = await fetch(
        '/api/wod/program/account/' +
          accountIdentifier +
          '/date/' +
          date +
          '/type/' +
          type
      );
      if (response?.status === 404) {
        const error = new Error('Program not found');
        error.status = 404;
        throw error;
      }
      const data = await response.json();
      console.log('Data', data);
      return data;
    } catch (error) {
      console.error('Error fetching Programming', error);
      throw error;
    }
  },
  async retrieveProgramming(identifier) {
    try {
      const response = await fetch('/api/<your_controller>/' + identifier);
      const data = await response.json();

      return data;
    } catch (error) {
      console.error('Error fetching Programming', error);
      throw error;
    }
  },
  async deleteProgramming(identifier) {
    try {
      let url = '/api/<your_controller>';
      let method = 'DELETE';
      const response = await fetch(url, {
        method: method,
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });
      if (response.ok) {
        const newProgramming = await response.json();
        console.log('Programming has been deleted:', newProgramming);
      }
    } catch (error) {
      console.log('Error deleting Programming', error);
    }
  }
};
export default ProgrammingService;
